import React from "react";
import "./Intro.css";
import Lc from "./Lc.jpeg";
import Typical from "react-typical";

const intro = () => {
  return (
    <>
      <div className="i">
        <div className="i-left">
          <div className="i-left-wrapper">
            <h2 className="i-intro">My name is</h2>
            <h2 className="i-name">L Chetan</h2>
            <div className="i-title">
              <div className="i-title-wrapper">
              <p>I'm a {" "}
               <span className="type-color"> <Typical loop={Infinity}
                wrapper="b"
                steps={[
                  'Student',1000,
                  'Web Developer',1000,
                  'Web Designer',1000,
                  'Freelancer',1000
                ]} />
                </span>
              </p>
              </div>
            </div>
            <div className="i-desc">
              I design and develop services for customers of all sizes,
              specialializing in creating stylish, mordern websites and web
              services.
            </div>
          </div>
         
        </div>
        <div className="i-right">
          <div className="i-bg">
            <img src={Lc} className="i-img" alt="My_Photo"></img>
          </div>
        </div>
      </div>
    </>
  );
};

export default intro;
